export default "__VITE_ASSET__DFpdEDUM__"